/* @generated from adl module ferovinum.sourcecontracts.negativestockadjustmentsaleorder */

import * as ADL from './../../runtime/adl';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.negative_stock_adjustment_sale_order` contract.
 */
export interface NegativeStockAdjustmentSaleOrderSource {
  id: common_strings.StringNE;
  negativeId: ferovinum_app_db.NegativeStockAdjustmentId;
  saleOrderId: ferovinum_app_db.SaleOrderId;
}

export function makeNegativeStockAdjustmentSaleOrderSource(
  input: {
    id: common_strings.StringNE,
    negativeId: ferovinum_app_db.NegativeStockAdjustmentId,
    saleOrderId: ferovinum_app_db.SaleOrderId,
  }
): NegativeStockAdjustmentSaleOrderSource {
  return {
    id: input.id,
    negativeId: input.negativeId,
    saleOrderId: input.saleOrderId,
  };
}

const NegativeStockAdjustmentSaleOrderSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.negativestockadjustmentsaleorder","decl":{"annotations":[{"value":{"modelName":"source__app_db.negative_stock_adjustment_sale_order","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.negative_stock_adjustment_sale_order` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"negativeId","default":{"kind":"nothing"},"name":"negativeId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NegativeStockAdjustmentId"}},"parameters":[]}},{"annotations":[],"serializedName":"saleOrderId","default":{"kind":"nothing"},"name":"saleOrderId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SaleOrderId"}},"parameters":[]}}]}},"name":"NegativeStockAdjustmentSaleOrderSource","version":{"kind":"nothing"}}};

export const snNegativeStockAdjustmentSaleOrderSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.negativestockadjustmentsaleorder", name:"NegativeStockAdjustmentSaleOrderSource"};

export function texprNegativeStockAdjustmentSaleOrderSource(): ADL.ATypeExpr<NegativeStockAdjustmentSaleOrderSource> {
  return {value : {typeRef : {kind: "reference", value : snNegativeStockAdjustmentSaleOrderSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.negativestockadjustmentsaleorder.NegativeStockAdjustmentSaleOrderSource" : NegativeStockAdjustmentSaleOrderSource_AST
};
